export const currentCategory = (state) => state.currentCategory;
export const currentGame = (state) => state.currentGame;


// WEBPACK FOOTER //
// ./src/store/getters.js